module.exports = __webpack_public_path__ + "media/images/gallery/oc_s-ee2bcc1fccfef558419bbb3915fd11c4.gif";